import Alert from '@mui/material/Alert';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import {
    isRefundAmountTooHigh,
    parseChf,
    TransactionRefundInputValues,
} from '../models/OperatorRefund.ts';
import { FormControl, Stack, TextField } from '@mui/material';

export function TransactionRefundResponseBanner({
    open,
    onClose,
    success,
}: {
    open: boolean;
    onClose: () => void;
    success: boolean;
}) {
    if (!open) {
        return null;
    }
    return (
        <Alert onClose={onClose} severity={success ? 'success' : 'error'}>
            {success ? (
                <Localized
                    de="Der angegebene Betrag wurde erstattet."
                    fr="Le montant spécifié a été remboursé."
                    it="L'importo specificato è stato rimborsato."
                    en="The specified amount was refunded."
                />
            ) : (
                <Localized
                    de="Das für die Transaktion verwendete Zahlungsmittel ist nicht mehr verfügbar, weshalb eine Rückerstattung nicht vorgenommen werden kann."
                    fr="Le moyen de paiement utilisé pour la transaction n'est plus disponible, c'est pourquoi un remboursement ne peut être effectué."
                    it="Il mezzo di pagamento utilizzato per la transazione non è più disponibile, per questo non è possibile effettuare il rimborso."
                    en="The payment method used for the transaction is no longer available and a refund cannot be issued."
                />
            )}
        </Alert>
    );
}

export function TransactionRefundInputFields({
    price,
    refundInputValues,
    setRefundInputValues,
}: {
    price: number;
    refundInputValues: TransactionRefundInputValues;
    setRefundInputValues: (values: TransactionRefundInputValues) => void;
}) {
    const formattedPrice = price.toFixed(2);

    return (
        <FormControl fullWidth>
            <Stack spacing={3}>
                <TextField
                    label={
                        <Localized
                            de={`Rückerstattungsbetrag (max. CHF ${formattedPrice})`}
                            fr={`Montant remboursement (max. CHF ${formattedPrice})`}
                            it={`Importo rimborso (max. CHF ${formattedPrice})`}
                            en={`Refund amount (max. CHF ${formattedPrice})`}
                        />
                    }
                    value={refundInputValues.amount}
                    onChange={e => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                            setRefundInputValues({
                                ...refundInputValues,
                                amount: value,
                            });
                        }
                    }}
                    inputMode="text"
                    autoFocus={true}
                    error={isRefundAmountTooHigh(
                        price,
                        parseChf(refundInputValues.amount),
                    )}
                    helperText={
                        isRefundAmountTooHigh(
                            price,
                            parseChf(refundInputValues.amount),
                        )
                            ? `Max. CHF ${formattedPrice}`
                            : null
                    }
                />
                <TextField
                    value={refundInputValues.remark}
                    label={
                        <Localized
                            de="Interne Bemerkungen"
                            fr="Remarques internes"
                            it="Osservazioni interne"
                            en="Internal remarks"
                        />
                    }
                    onChange={e =>
                        setRefundInputValues({
                            ...refundInputValues,
                            remark: e.target.value,
                        })
                    }
                    inputMode="text"
                />
            </Stack>
        </FormControl>
    );
}
